/**
 *  @class
 *  @function ProductRecommendations
 */
 
class ProductRecommendations extends HTMLElement {
  constructor() {
    super(); 
    this.parent = this.closest('.product-recommendations--parent'); 
  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations'); 
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML; 
          if ( this.parent ) {
            this.parent.classList.add('product-recommendations--full'); 
            if ( document.body.classList.contains('open-cart')) {
              this.parent.classList.add('active');
            }
          } 
        } 
        this.classList.add('product-recommendations--loaded'); 
      })
      .catch(e => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

//customElements.define('product-recommendations', ProductRecommendations);

/*  start   */
// if($("body").hasClass("template-product")) {
//   var productpage = document.querySelector('#metafield_value').getAttribute("data-metafield");
//   var productidvalue = document.querySelector('#product_id_value').getAttribute("data-id");
//   var producPageLoadedOcs = 0;
// } else {
//   var producPageLoadedOcs = 1;
// } 
// var metafieldValue = '';

if ($("body").hasClass("template-product")) {
  const metafieldEl = document.querySelector('#metafield_value');
  const productIdEl = document.querySelector('#product_id_value');
  let productpage = '';
  let productidvalue = '';
  if (metafieldEl) {
    productpage = metafieldEl.getAttribute("data-metafield");
  }
  if (productIdEl) {
    productidvalue = productIdEl.getAttribute("data-id");
  }
  var producPageLoadedOcs = 0;
} else {
  var producPageLoadedOcs = 1;
}
var metafieldValue = '';


var element = document.querySelector('#metafield_value_cart');
let cartModifiedOcs = 0;
let checkCartChanges; 
function checkCartDrawerStatus() {
  if ($('#Cart-Drawer').hasClass('active') || (element && element.hasAttribute('data-metafield'))) {
    if(cartModifiedOcs == 0) {
      setTimeout(() => {
        var cartpage = $("#metafield_value_cart").data("metafield");
        cartModifiedOcs = 1;
        checkCartDrawerProducts(cartpage);  
        clearInterval(checkCartChanges);
      }, 600);
      setTimeout(() => {
        var cartpage = $("#metafield_value_cart").data("metafield");
        cartModifiedOcs = 1;
        checkCartDrawerProducts(cartpage);  
        clearInterval(checkCartChanges);
      }, 1000);
    } 
  }else{  
    checkCartDrawerProducts(productidvalue);
  }
  if(producPageLoadedOcs == 0) {
    producPageLoadedOcs = 1;
    setTimeout(() => {
      checkProductListPage(productidvalue);  
    }, 1000);
  }
}
checkCartDrawerStatus();
if($("body").hasClass("template-cart")) {
  setTimeout(() => {
    checkProductListPage(productidvalue);
  }, 1000);
} 
$("#AddToCart").click(function(e) { 
  cartModifiedOcs = 0; 
  checkCartDrawerStatus();
});

$(document).on("click", ".product-cart-item .product-cart-item-info .remove", function(e) {
  setTimeout(() => {
    var cartpage = $("#metafield_value_cart").data("metafield");
    cartModifiedOcs = 1;
    checkCartDrawerProducts(cartpage);  
    clearInterval(checkCartChanges);
  }, 1500);
});

function getMetafieldValue(productidvalue) {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: 'https://www.hexagona.com/api/2024-01/graphql.json',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            headers: {
                'X-Shopify-Storefront-Access-Token': '9223c0ed50cf3ab28d4db9d8a9bbda8a',
                'Access-Control-Allow-Origin': '*', 
                'Accept-Language': 'fr-FR',
            },
            data: JSON.stringify({
                query: `
                    {
                      product(id: "gid://shopify/Product/${productidvalue}") {
                        metafield(key: "ligne", namespace: "custom") {
                          value
                        }
                      }
                    }
                `
            }),
            cache: false,
            success: function(response) {   
                const metafieldValue = response.data.product?.metafield?.value;
                resolve(metafieldValue);
                //console.log(metafieldValue);
            },
            error: function(xhr, status, error) {
                console.error('AJAX Error:', error);
                reject(error);
            }
        });
    });
}
function checkProductListPage(productidvalue) {
    getMetafieldValue(productidvalue)
        .then(metafieldValue => {
            $.ajax({
                url: 'https://www.hexagona.com/api/2024-01/graphql.json', // Assuming your GraphQL endpoint is at this URL
                type: 'POST', // Shopify Storefront API requires POST requests
                dataType: 'json',
                contentType: 'application/json',
                headers: {
                    'X-Shopify-Storefront-Access-Token': '9223c0ed50cf3ab28d4db9d8a9bbda8a', // Replace with your actual Storefront API access token
                    'Access-Control-Allow-Origin': '*', 
                },
                
                data: JSON.stringify({
                    query: `
                        {
                          products(first: 4 query: "metafield:'custom.ligne':'${metafieldValue}'") {
                              edges {
                                node {
                                  handle
                                  id
                                  title
                                  metafield(key: "ligne", namespace: "custom") {
                                    key
                                    namespace
                                    value
                                  }
                                  images(first: 4) {
                                      nodes {
                                          altText
                                          url
                                      }
                                  }
                                  priceRange {
                                    maxVariantPrice {
                                      amount
                                    }
                                  }
                                  variants(first: 3, reverse: true) {
                                    nodes {
                                      id
                                      image {
                                        url(transform: {maxWidth: 600, crop: CENTER})
                                        altText
                                      }
                                      price {
                                        amount
                                      }
                                    }
                                  }
                                }
                              }
                            }
                        } `
                }),
                cache: false,
                success: function(response) {
                  var langHtml = document.querySelector("html"); 
                  if(langHtml.getAttribute("lang") == "fr") {
                    quickView = "Aperçu rapide";
                    store_language = "";
                  }else if(langHtml.getAttribute("lang") == "en"){
                    quickView = "Quick View";
                    store_language = "en/";
                  }
                  var productsHTML = '<ul>';  
                  var productlist = '<ul class="products related-products cross-selling-ocs collection row small-up-1 medium-up-4 no-padding">';
                                    response.data.products.edges.forEach(function(product) {
              productlist += '<li class="columns"><product-card class="product-card text-left"><figure class="product-featured-image thb-hover"><a href="/' + store_language + 'products/' + product.node.handle + '" title="'+ product.node.title + '" class="product-featured-image-link aspect-ratio aspect-ratio--adapt" style="--padding-bottom: 150.00000000000003%;">';
                                      product.node.images.nodes.forEach(function(image, keys) {
                                        if(keys ==0){
                                          productlist += '<img class="product-primary-image lazyautosizes ls-is-cached lazyloaded" width="1600" height="2400" data-sizes="auto" src="'+image.url+'" data-srcset="'+image.url+' 375w, '+image.url+' 770w" alt="#couleur_noir" style="object-position: 50.0% 50.0%;" sizes="415px" srcset="'+image.url+' 375w,'+image.url+' 770w">';
                                        }else{
                                          productlist += '<img class="product-secondary-image lazyautosizes lazyloaded" width="1600" height="2400" data-sizes="auto" src="'+image.url+'" data-srcset="'+image.url+' 375w, '+image.url+' 770w" alt="#couleur_noir" style="object-position: 50.0% 50.0%;" sizes="415px" srcset="'+image.url+' 375w,'+image.url+' 770w">';
                                        }
                                    });  
                    productlist += '<quick-view class="product-card-quickview" href="#Product-Drawer" data-product-handle="' + product.node.handle + '" tabindex="-1"><div class="loading-overlay"><svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-accent)"></circle></svg></div><span>'+quickView+'</span></quick-view>';
                    productlist += '<ul class="product-secondary-images-nav"><li class=""></li><li class=""></li><li class=""></li></ul></a>';
                    productlist += '</figure>';
                    productlist += '<div class="product-card-info"><div class="product-card-collection row p-0 m-0"><div class="small-6 large-6"><a href="/' + store_language + 'collections/' + product.node.metafield.value + '">' + product.node.metafield.value + '</a></div>';
                    productlist += '<div class="small-6 large-6 text-right"><span class="price"><ins><span class="amount">'+parseFloat(product.node.priceRange.maxVariantPrice.amount).toFixed(2).replace('.', ',')+'€</span></ins><small class="unit-price  hidden"><span></span><span class="unit-price-separator">/</span><span></span></small></span></div></div>';                            
                     productlist += '<a href="/' + store_language + 'products/'+ product.node.handle + '" title="'+ product.node.title + '" class="product-card-title">'+ product.node.title + '</a></div>';
                      });
                    productlist += '</ul>'; 
                    $('#products-container').html(productlist); 
                  setTimeout(() => {
                    if($(window).width() < 767) {
                      var $crossSelling = $('.cross-selling-ocs').flickity({
                         cellAlign: 'left',
                         contain: false,
                      });
                      $crossSelling.flickity('resize');
                    }
                  }, 100);
                },
                error: function(xhr, status, error) {
                    console.error('AJAX Error:', error);
                }
            }); 
        })
        .catch(error => {
            console.error('Error fetching metafield value:', error);
        });
}  
async function checkCartDrawerProducts(cartpage) { 
    if (cartpage !== "Confort") {
        try {
            const metafieldValue = await getMetafieldValue(cartpage);
            cartpage = metafieldValue; // Update cartpage with metafield value
        } catch (error) {
            console.error('Error fetching metafield value:', error);
            return; // Exit the function if there's an error
        }
    } 
    try {
        const response = await $.ajax({
            url: 'https://www.hexagona.com/api/2024-01/graphql.json',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            headers: {
                'X-Shopify-Storefront-Access-Token': '9223c0ed50cf3ab28d4db9d8a9bbda8a',
                'Access-Control-Allow-Origin': '*',
            }, 
            data: JSON.stringify({
                query: `
                    {
                      products(first: 4, query: "metafield:value:'${cartpage}'") {
                          edges {
                            node {
                              handle
                              id
                              title
                              metafield(key: "ligne", namespace: "custom") {
                                key
                                namespace
                                value
                              }
                              images(first: 1) {
                                  nodes {
                                      altText
                                      url
                                  }
                              }
                              priceRange {
                                maxVariantPrice {
                                  amount
                                }
                              }
                              variants(first: 1, reverse: true) {
                                nodes {
                                  id
                                  image {
                                    url(transform: {maxWidth: 600, crop: CENTER})
                                    altText
                                  }
                                  price {
                                    amount
                                  }
                                }
                              }
                            }
                          }
                        }
                    } `
            }),
        });

        // Process the response
       var langHtml = document.querySelector("html"); 
       var store_language = ""; 
        if(langHtml.getAttribute("lang") == "en") { 
          store_language = "en/";
        }
        const cartproductlist = await response.data.products.edges.map((product) => {
            return `<div class="cart-drawer--recommendations--products">
                        <product-card class="product-cart-item">` +
                            product.node.variants.nodes.map((variant) => {
                                return `<div class="product-cart-item-image">
                                            <img class="lazyautosizes ls-is-cached lazyloaded" width="1600" height="2400" data-sizes="auto"
                                                src="${variant.image.url}"
                                                data-srcset="${variant.image.url}"
                                                alt="#couleur_marron" sizes="100px"
                                                srcset="${variant.image.url}">
                                        </div>
                                        <div>`;
                                        }).join('') +
                                            `<a href="/${store_language}products/${product.node.handle}" title="${product.node.title}" class="cart-product-link">${product.node.title}</a>
                                            <span class="price">
                                                <ins><span class="amount">${parseFloat(product.node.priceRange.maxVariantPrice.amount).toFixed(2).replace('.', ',')} €</span></ins>
                                                <small class="unit-price hidden">
                                                    <span></span>
                                                    <span class="unit-price-separator">/</span>
                                                    <span></span>
                                                </small>
                                            </span>
                                        </div>
                        </product-card>
                    </div>`;
        }).join(''); 
      setTimeout(() => {
        $('.cart-drawer--recommendations--products').html(cartproductlist)  
      }, 1500);
      document.querySelector('.cart-drawer--recommendations--products').innerHTML = cartproductlist;
    } catch (error) {
        console.error('AJAX Error:', error);
    }
}


/*  end   */
